export class SpineOptimizeConst {
}
SpineOptimizeConst.BONEVERTEX = 22;
SpineOptimizeConst.RIGIDBODYVERTEX = 9;
